// SubjectDetailsModal.js
import React from 'react';
import { Modal, Image, Row, Col, Card, Button, Tag, Space } from 'antd';
import { useTranslation } from 'react-i18next';

const SubjectDetailsModal = ({ subject, open, onClose }) => {
  const { t } = useTranslation();

  if (!subject) return null;

  const renderSpecification = (spec) => {
    let items = [];
  
    try {
      // If it's a JSON string, parse it
      if (typeof spec === 'string') {
        const parsed = JSON.parse(spec);
        if (Array.isArray(parsed)) {
          items = parsed;
        } else {
          // Fallback: assume it's newline-separated
          items = spec.split('\n').filter(item => item.trim() !== '');
        }
      } else if (Array.isArray(spec)) {
        items = spec;
      }
    } catch (e) {
      // Fallback on error
      items = spec.split('\n').filter(item => item.trim() !== '');
    }
  
    return (
      <div style={{ marginTop: 8 }}>
        {items.map((item, idx) => (
          <Tag color="blue" key={idx} style={{ marginBottom: 4 }}>
            {item}
          </Tag>
        ))}
      </div>
    );
  };
  

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={400}
      height={800}
      centered
      footer={null}
      className="subject-detail-modal"
    >
      <div className="subject-modal-content">
        <div
            className="subject-modal-header"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              boxSizing: 'border-box',
              height: '250px',
            }}
          >
            <Image
              src={subject.image_url || '/images/advisorlogo.png'}
              alt={subject.title}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',  
                borderRadius: '8px',
                display: 'block',
              }}
              fallback="/images/advisorlogo.png"
              preview={false}
            />
          </div>

        <div className="subject-modal-title-overlay" style={{ textAlign: 'center', marginTop: '16px' }}>
          <h2 style={{ fontWeight: 'bold' }}>{subject.title}</h2>
          <Tag color="blue">{subject.code}</Tag>
        </div>

        <div>
          <Card bordered={false} style={{ backgroundColor: '#fafafa', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', marginBottom: '24px' }}>
              <div>
                <span style={{ fontWeight: 'bold', color: '#555' }}>{t('group')}: </span>
                <Tag color="cyan" style={{ marginLeft: 8 }}>{subject.subjectgroup}</Tag>
              </div>
              <div>
                <span style={{ fontWeight: 'bold', color: '#555' }}>{t('level')}: </span>
                <Tag color="purple" style={{ marginLeft: 8 }}>{subject.level}</Tag>
              </div>
              <div>
                <span style={{ fontWeight: 'bold', color: '#555' }}>{t('year')}: </span>
                <Tag color="orange" style={{ marginLeft: 8 }}>{subject.year}</Tag>
              </div>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <span style={{ fontWeight: 'bold', color: '#555' }}>{t('description')}: </span>
              <div style={{ marginTop: 8, whiteSpace: 'pre-wrap' }}>{subject.description}</div>
            </div>

            {subject.specification && (
              <div style={{ marginTop: '16px' }}>
                <span style={{ fontWeight: 'bold', color: '#555' }}>{t('Related Courses')}: </span>
                {renderSpecification(subject.specification)}
              </div>
            )}
          </Card>

          <div style={{ textAlign: 'right', marginTop: '24px' }}>
            <Button type="primary" onClick={onClose} danger>{t('close')}</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SubjectDetailsModal;